WiseMetering.Views.FolderDetailsAccordion = Backbone.Marionette.ItemView.extend({
    template: 'templates/folders/details',

    modelEvents: {
        'change': 'render'
    },

    events: {
        'click #edit_attributes': 'editAttributes'
    },

    editAttributes: function(event) {
        event.stopPropagation();
        new WiseMetering.Views.FolderManage({ model: this.model, title: i18next.t('modal.title.folders.edit') });
    }
});
